import { useState, useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";
import { logger } from "@/utils/logger";

export interface ProfileSetup {
  profile: any | null;
  needsSetup: boolean;
  loading: boolean;
  refetch: () => Promise<void>;
}

export const useProfileSetup = (): ProfileSetup => {
  const { user } = useAuth();
  const [profile, setProfile] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchProfile = async () => {
    if (!user?.id) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const { data, error } = await supabase
        .from("profiles")
        .select("id, company_name, email")
        .eq("id", user.id)
        .single();

      if (error) throw error;
      setProfile(data);
    } catch (error) {
      logger.error("Error fetching profile:", error);
      setProfile(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [user?.id]);

  const needsSetup = !loading && (!profile?.company_name || profile.company_name.trim() === "");

  return {
    profile,
    needsSetup,
    loading,
    refetch: fetchProfile,
  };
};
